import {QuantityUnit} from "@/model/QuantityUnit";

export default function(unit: string): string {
    const enumValue = QuantityUnit[unit as keyof typeof QuantityUnit];

    switch (enumValue) {
        case QuantityUnit.GRAMS:
            return "g";
        case QuantityUnit.KILOGRAMS:
            return "kg";
        default:
            return "kg";
    }
}
